import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css"; // 引入重置样式包
import "@/assets/styles/common.less"; // 引入公用样式
import UI from "./components/library"; // 引入全局用的插件
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/assets/styles/iconfont.css"; // 引入阿里图标库
import locale from "element-plus/dist/locale/zh-cn.mjs";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// 插件的使用，在main.js使用app.use(插件)
createApp(App).use(ElementPlusIconsVue).use(ElementPlus, { locale }).use(store).use(router).use(UI).mount("#app");
